import {NgModule} from "@angular/core";
import {RouterModule, Routes} from "@angular/router";
import {PosExperiencesComponent} from "./pos-experiences.component";
import {PosExperienceEditComponent} from "./pos-experience-edit/pos-experience-edit.component";

const routes: Routes = [
  {
    path: "",
    component: PosExperiencesComponent
  },
  {
    path: ":type",
    component: PosExperienceEditComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PosExperiencesRoutingModule {}
